import moment from "moment";

export const convertDate = (targetDate: string) => {
  let date = new Date(targetDate);

  date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  console.log(`${date.getFullYear()}-0${date.getMonth()}-${date.getDate()}`);
  console.log(date);

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

export const formatDate = (date: string) => {
  return moment(date).utc().format("DD/MM/YY");
};

export const formatFullDate = (date: string) => {
  return moment(date).format("DD/MM/YYYY");
};

export const formatDateWithTime = (date: string) => {
  return moment.utc(date).format("DD/MM/YY hh:mm:ss A");
};

/**
 * Converts UTC time to IST (Indian Standard Time) by adding 5 hours and 30 minutes
 * @param utcTime - UTC time string
 * @returns IST time string formatted as 'YYYY-MM-DD HH:mm:ss'
 */
export const convertToIST = (utcTime: string | null | undefined): string => {
  if (!utcTime) return "--";
  // Parse the UTC time and add 5 hours 30 minutes
  const istTime = moment.utc(utcTime);
  // Format the time as 'YYYY-MM-DD HH:mm:ss'
  return istTime.format("YYYY-MM-DD HH:mm:ss");
};

/**
 * Formats UTC date with time in IST (Indian Standard Time)
 * @param date - UTC date string
 * @returns IST date string formatted as 'DD/MM/YY hh:mm:ss A'
 */
export const formatDateWithTimeIST = (date: string | null | undefined): string => {
  if (!date) return "--";
  // Parse UTC and convert to IST, then format
  return moment.utc(date).utcOffset("+05:30").format("DD/MM/YY hh:mm:ss A");
};
